import StarMovie from "../assets/ActivitiesImg/UnderSkyMovie.jpg";
import Karoake from "../assets/ActivitiesImg/Karoake.jpg";
import Bonfire from "../assets/ActivitiesImg/Bonfire.jpg";
import Pool from "../assets/ActivitiesImg/PrivatePool.jpg";
import Tub from "../assets/ActivitiesImg/SoakingTub.jpg";
import Yoga from "../assets/ActivitiesImg/Yoga.jpg";
import Fun from "../assets/ActivitiesImg/FunGame.jpg";
import Chill from "../assets/ActivitiesImg/Chill.jpg";
import explore1 from "../assets/ExploreImg/KD.png";
import explore2 from "../assets/ExploreImg/CF.png";
import explore3 from "../assets/ExploreImg/JL.png";
import explore4 from "../assets/ExploreImg/IFC.png";
import explore5 from "../assets/ExploreImg/BRB.jpg";
import gallaryimg1 from "../assets/ResortGallery/RG20.jpg";
import gallaryimg2 from "../assets/ResortGallery/RG21.jpg";
import gallaryimg3 from "../assets/ResortGallery/RG16.jpg";
import gallaryimg4 from "../assets/ResortGallery/RG17.jpg";
import gallaryimg5 from "../assets/ResortGallery/RG18.jpg";
import gallaryimg6 from "../assets/ResortGallery/RG19.jpg";

const ActivitiesInfo = [
  {
    src: StarMovie,
    Activity: "ENTERTAINMENT",
    title: "Under the Star Movie",
    Description:
      "Enjoy a magical movie night under the open sky, surrounded by nature's serenity.",
  },
  {
    src: Karoake,
    Activity: "ENTERTAINMENT",
    title: "Karaoke Entertainment",
    Description:
      "Sing your heart out with friends and family in a fun-filled karaoke session.",
  },
  {
    src: Bonfire,
    Activity: "RELAXATION",
    title: "Cozy Bonfire Nights",
    Description:
      "Gather around the warmth of a crackling bonfire and create unforgettable memories.",
  },
  {
    src: Pool,
    Activity: "RECREATION",
    title: "Private Swimming Pool",
    Description:
      "Take a refreshing dip in your own secluded pool, offering ultimate relaxation.",
  },
  {
    src: Tub,
    Activity: "WELLNESS",
    title: "Luxurious Soaking Tub",
    Description:
      "Indulge in a soothing bath experience designed for pure comfort and tranquility.",
  },
  {
    src: Yoga,
    Activity: "MINDFULNESS",
    title: "Yoga & Meditation Retreat",
    Description:
      "Rejuvenate your mind and body with peaceful yoga and meditation sessions.",
  },
  {
    src: Fun,
    Activity: "FAMILY",
    title: "Outdoor Play Area for Kids",
    Description:
      "A fun and safe space where little ones can run, play, and explore.",
  },
  {
    src: Chill,
    Activity: "COMFORT",
    title: "Netflix & Chill Experience",
    Description:
      "Enjoy your favorite movies and shows in the comfort of your luxurious retreat.",
  },
];
const testimonialsData = [
  {
    title: "BALI FEELS IN BANGALORE",
    description:
      "Newly opened, it's calm and serene. A big shoutout to the entire team for top-notch hospitality, great food, and best-in-class suites.",
    name: "Richa Arora",
  },
  {
    title: "QUAINT, BEAUTIFUL RESORT",
    description:
      "Just outside Bangalore, this serene resort offers private pools, in-room dining, karaoke, starlit movies, and a cozy bonfire—perfect for a quick getaway!",
    name: "Krishnaprasad Jagadish",
  },
  {
    title: "7 STAR EXPERIENCE AND HOSPITALITY",
    description:
      "A unique luxury escape just 2-2.5 hours from North Bengaluru—perfect for a quick one-day break from the daily hustle.",
    name: "Mayank Bhandari"
  },
  {
    title: "BEAUTIFUL RESORT IN KANAKPURA",
    description:
      "A luxurious retreat with spacious rooms, top-notch amenities, and one of the largest washrooms. Relax in private pools and a Jacuzzi!",
    name: "Digital Vishal"
  },
  {
    title: "THIS PLACE IS A HIDDEN GEM!",
    description:
      "An incredible Bali-style villa near Bangalore, offering a serene tropical escape with stunning architecture, lush greenery, and beautifully designed interiors.",
    name: "Bhavin Patel"
  },
];
const exploreData = [
  {
    src: explore1,
    title: "KABBALADURGA",
    description:
      "A spot loved by a majority of local adventure enthusiasts, Kabbaladurga is an exquisite Hill located at a short distance of 20 km from Kanakapura. If you want to fill your vacation with adrenaline pumping action, this has to be one of the best places to visit near Kanakapura. A 3 km long trail takes you to the top of this hillock from where you can indulge in the sweeping views of the surrounding settlements.",
    fullImage: true,
  },
  {
    src: explore2,
    title: "CHUNCHI FALLS",
    description:
      "Come here with your family and friends, and spend some hours of pure ecstasy and enjoyment in the refreshing aura created by the waterfall's roar and fervour. For the most memorable picnic experience near Chunchi Falls, visit the spot during monsoon season when the plunge is mightier and the surroundings are vibrant.",
    fullImage: false,
  },
  {
    src: explore3,
    title: "JANAPADA LOKA",
    description:
      "A unique museum specializing in the culture and art of the region, Janapada Loka is one of the finest places to visit in Kanakapura, especially for those who are eager to learn about this impressive aspect of the state. A tour of the museum is a great opportunity for one to experience the spirit of Karnataka through an extensive range of village folk arts that is on display here.",
    fullImage: true,
  },
  {
    src: explore4,
    title: "INNOVATIVE FILM CITY",
    description:
      "Apt for a fun-filled family outing, Innovative Film City is one of those places to see in Kanakapura that bring this city to the list of the most rewarding getaways near Bangalore. Featuring a wide range of attractions for adults as well as kids, this is more than an ordinary amusement park. Spanning across an area of 58 acres, this themed park encompasses TV show sets, thrilling rides, museums etc, making it a bundle of joy.",
    fullImage: false,
  },
  {
    src: explore5,
    title: "BILIKAL RANGASWAMY BETTA",
    description:
      "A sheer delight for the lovers of thrill and adventure, Bilikal Rangaswamy Betta offers a perfect terrain for trekking, making for one of the most remarkable places to visit in Kanakapura with friends. Since not too many tourists are aware of this place, you can look forward to experiencing calm and solace during your excursion to climb to the top.",
    fullImage: true,
  },
];
const GallaryImgData = [
  { src: gallaryimg1, height: 513 },
  { src: gallaryimg2, height: 252 },
  { src: gallaryimg4, height: 513 },
  { src: gallaryimg5, height: 252 },
  { src: gallaryimg1, height: 252 },
  { src: gallaryimg3, height: 252 },
  { src: gallaryimg4, height: 252 },
  { src: gallaryimg6, height: 252 },
];
export { ActivitiesInfo, testimonialsData, exploreData, GallaryImgData };
